import type {
  ActiveItemFilter,
  AgentsTreeAgentNode,
  AgentsTreeAgentTypeNode,
  AgentsTreeRootNodeChild,
} from './AgentsSidebar.types'
import {AgentTreeItemType} from './AgentsSidebar.types'

export const getIsEqualActiveItemFilters: (
  item1: ActiveItemFilter | null,
  item2: ActiveItemFilter | null,
) => boolean = (item1, item2) => item1?.id === item2?.id && item1?.type === item2?.type
export const isAgentTypeNode = (node: AgentsTreeRootNodeChild): node is AgentsTreeAgentTypeNode =>
  node.type === AgentTreeItemType.AGENT_TYPE
export const isAgentNode = (node: AgentsTreeRootNodeChild): node is AgentsTreeAgentNode =>
  node.type === AgentTreeItemType.AGENT
